import React, { useState, useContext } from 'react';
import { useHistory } from "react-router-dom";

import consumoContext from '../../../context/consumos/consumoContext';
import proyectoContext from '../../../context/proyectos/proyectoContext';

const NuevoConsumo = () => {

    const history = useHistory();

    // extraer si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;

    // Array destructuring para extraer el proy actual
    const [proyectoActual] = proyecto;

    // obtener el state de consumo
    const consumosContext = useContext(consumoContext);
    const { agregarConsumo, obtenerConsumosPyt } = consumosContext;

    // state para el consumo
    const [consumo, setConsumo] = useState({
        nombre: '',
        potencia: 0,
        uso: 0,
        consumoE: 0,
        proyectoId: 0
    });

    // extraer nombre del aparato consumidor
    const { nombre, potencia, uso } = consumo;

    // lee los contenidos del input
    const onChangeConsumo = e => {
        setConsumo({
            ...consumo,
            [e.target.name] : e.target.value
        })
    }

    // cuando el usuario envia (submit) el consumo 
    const onSubmitConsumo = e => {
        e.preventDefault();

        // validar el consumo
        if (nombre === '') {
            return;
        }

        // agregar el consumo al state
        consumo.proyecto = proyectoActual._id
        agregarConsumo(consumo);
        
        obtenerConsumosPyt(proyectoActual._id);

        // reiniciar el form
        setConsumo({
            nombre: '',
            potencia: 0,
            uso: 0,
            consumoE: 0,
            proyectoId: 0
        })
        history.push('/proyectos/consumos');
    }

    return (
        <div className="row justify-content-center">
            <div className="col-md-6">
                <form
                    onSubmit={onSubmitConsumo}
                >
                <fieldset>
                    <legend><h2>Ingrese los datos para un nuevo cálculo</h2></legend>
                        <div className="form-group">
                            <label for="aparato">Nombre Electrodoméstico</label>
                            <input 
                                type="text" 
                                className="form-control consumotxt" 
                                id="aparato" 
                                aria-describedby="aparato" 
                                placeholder="Nombre Electrodoméstico" 
                                name="nombre"
                                value={ nombre }
                                onChange={onChangeConsumo}
                            />
                            <small id="ayudaaparato" className="form-text text-muted">Nombre, marca, o cualquier descripción que desee</small>
                        </div>
                        <div className="form-group">
                            <label for="potencia">Potencia en Watts</label>
                            <input 
                                type="number" 
                                className="form-control consumotxt" 
                                id="potencia" 
                                aria-describedby="potencia" placeholder="Potencia del electrodoméstico"
                                name="potencia"
                                value={ potencia }
                                onChange={onChangeConsumo}
                            />
                            <small id="ayudaaparato" className="form-text text-muted">Este dato se encuentra generalmente en la parte posterior del aparato en la entrada del cable de poder</small>
                        </div>
                        <div className="form-group">
                            <label for="uso">Uso diario del Electrodoméstico en horas</label>
                            <input 
                                type="number" 
                                className="form-control consumotxt" 
                                id="uso" 
                                aria-describedby="uso" 
                                placeholder="Tiempo de uso del aparato"
                                name="uso" 
                                value={ uso }
                                onChange={onChangeConsumo}
                                />
                            <small id="ayudaaparato" className="form-text text-muted">Tiempo que a diario se utiliza el electrodoméstico. Para aparatos que se utilizan una vez a la semana, se puede promediar dividiendo por 7</small>
                        </div>                    
                        <button type="submit" className="btn btn-primary text-uppercase">Agregar Consumo</button>
                    </fieldset>
                </form>
            </div>
        </div>  
        
    );
}
 
export default NuevoConsumo;